export default {
  'footer.fall-facilities': 'All facilities',
  'footer.about-avelios-medical': 'About {tenant}',
  'footer.imprint': 'Legal notice',
  'footer.privacy': 'Privacy policy',
  'footer.language': 'Language',
  'footer.terms-of-usage': 'Terms of use',
  'footer.navigation': 'Navigation',
  'footer.credits': 'External resources',
  'footer.credits.external': 'Links',
  'footer.facilities': 'Medical facilities',

  'credits.title': 'External resources',
  'select.language': 'Select language',

  'credits.text':
    'In order to also design its own services graphically in the best possible way for users, {tenant} incorporates graphics from external providers in parts of the patient portal. Below you will find corresponding links to the respective graphics in order to respect the copyright and to give credit to the creators of the graphics.',
};
